import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import type { Schedule } from "@/pages/human-resources/time-management/business/schedule/Schedule.ts";
import type { CancelDraftSchedulesIn } from "@/pages/human-resources/time-management/endpoints/schedules/inout/CancelDraftSchedulesIn.ts";
import { cancelDraftSchedules } from "@/pages/human-resources/time-management/endpoints/schedules/SchedulesEndpoints.ts";
import useScheduleDataStateDispatch from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/useScheduleDataStateDispatch.ts";
import useScheduleReferenceData from "@/pages/human-resources/time-management/schedules/reference-provider/useScheduleReferenceData.ts";

export default function useCancelDraftSchedules(): UseMutationResult<
  void,
  Error,
  Schedule[]
> {
  const {
    siteData: { siteId },
  } = useScheduleReferenceData();
  const dispatch = useScheduleDataStateDispatch();
  return useMutation({
    mutationFn: (schedules: Schedule[]) => {
      dispatch({
        type: "employeesMarkStale",
        employeesIds: schedules.map((s) => s.employeeId),
      });
      const input: CancelDraftSchedulesIn = {
        siteId: parseInt(siteId),
        scheduleIds: schedules
          .map((s) => parseInt(s.id ?? s.publishedId ?? "0"))
          .filter((id) => id !== 0),
      };
      return cancelDraftSchedules(input);
    },
    onSettled: () => {
      dispatch({ type: "schedulesMarkStale" });
    },
  });
}
